import { render, staticRenderFns } from "./ProductCollapsableItem.vue?vue&type=template&id=1efdfbf2&"
import script from "./ProductCollapsableItem.vue?vue&type=script&lang=js&"
export * from "./ProductCollapsableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports